<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (slice.children[activeSlot() + 1] &&
  hasContent(slice.children[activeSlot() + 1][0]) &&
  !activeSlotSettings?.hidden) {
  <render-slice-slot
    data-e2e="render-slice-slot"
    class="slot"
    [slice]="slice"
    [slot]="(activeSlot() + 1).toString()"
    [attr.data-slot]="activeSlot() === 0 ? 'A' : 'B'"
    [ngStyle]="activeSlotSettings ? getSlotStyles(activeSlotSettings) : {}">
  </render-slice-slot>
}
